// extracted by mini-css-extract-plugin
module.exports = {"root":"SkeletonCard_root__fwEaW","image":"SkeletonCard_image__tnLyc","shimmer":"SkeletonCard_shimmer__UsCK_","title":"SkeletonCard_title__cG8g7"};